import api from './authService';

// Admin
export const getAdminSupportTicket = async (id) => {
  const response = await api.get(`/admin/support-tickets/${id}`);
  return response.data;
};

export const updateAdminSupportTicket = async (id, data) => {
  const response = await api.put(`/admin/support-tickets/${id}`, data);
  return response.data;
};

export const replyToSupportTicket = async (id, data) => {
  const response = await api.post(`/admin/support-tickets/${id}/reply`, data);
  return response.data;
};

// Vendor
export const getVendorSupportTickets = async (params = {}) => {
  const response = await api.get('/vendor/support-tickets', { params });
  return response.data;
};

export const getVendorSupportTicket = async (id) => {
  const response = await api.get(`/vendor/support-tickets/${id}`);
  return response.data;
};

export const createVendorSupportTicket = async (data) => {
  const response = await api.post('/vendor/support-tickets', data);
  return response.data;
};

export const replyToVendorSupportTicket = async (id, data) => {
  const response = await api.post(`/vendor/support-tickets/${id}/reply`, data);
  return response.data;
};
